<template>
    <v-container class="contracts">
        <ContractList gridclass="md6" />
        <ContractAdditionalInsuranceQuestions />
        <v-layout row wrap class="contract-overview-box">
            <v-flex class="pa-2" xs12 md6>
                <v-card to="/contract/add/" ripple hover>
                    <v-layout>
                        <v-flex xs3>
                            <v-avatar class="avatar"><v-icon>note_add</v-icon></v-avatar>
                        </v-flex>
                        <v-flex xs9>
                            <v-card-title primary-title>
                                <div>
                                    <div class="headline">Weitere Verträge hinzufügen</div>
                                    <div>Lassen Sie uns Ihre bestehenden Versicherungen digitalisieren. Ein Ansprechpartner, alles immer aktuell.</div>
                                </div>
                          </v-card-title>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>

            <v-flex v-if="!$store.state.mandate.url" class="pa-2" xs12 md6>
                <v-card to="/mandate" ripple hover>
                  <v-layout>
                      <v-flex xs3>
                          <v-avatar class="avatar"><v-icon>screen_share</v-icon></v-avatar>
                      </v-flex>
                      <v-flex xs9>
                          <v-card-title primary-title>
                              <div>
                                  <div class="headline">Maklervertrag</div>
                                  <div>Sollen wir alle bestehenden Versicherungsverträge kostenfrei &amp; automatisch zu VAPP hinzufügen?</div>
                              </div>
                          </v-card-title>
                      </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>

            <v-flex v-if="$store.getters['contracts/getAllContracts'].length>0" class="pa-2" xs12 md6>
                <v-card ripple hover @click="show_check_dialog = true">
                    <v-layout>
                        <v-flex xs3>
                            <v-avatar><v-icon>plagiarism</v-icon></v-avatar>
                        </v-flex>
                        <v-flex xs9>
                            <v-card-title primary-title>
                                <div>
                                    <div class="headline">Tarif-Check bis 30% Rabatt</div>
                                    <div>Kostenfrei Ihre Versicherungen vom Versicherungs-Experten vergleichen lassen: Kosten runter, Leistung hoch!</div>
                                </div>
                            </v-card-title>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-flex>

            <TariffcheckModal :show_check_dialog.sync="show_check_dialog" />
        </v-layout>
    </v-container>
</template>

<script>
import ContractList from '@/components/ContractList';
import TariffcheckModal from '@/components/TariffcheckModal';
import ContractAdditionalInsuranceQuestions from '@/components/ContractAdditionalInsuranceQuestions';

export default {
    data() {
        return {
            show_check_dialog: false
        }
    },

    components: {
        ContractList,
        TariffcheckModal,
        ContractAdditionalInsuranceQuestions
    },
}
</script>
